import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function ValiantLiquidityDetails({ triggerType }: Props) {
  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
    </div>
  );
}
